"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnitLocation = exports.decodeLocation = void 0;
/**
 * decodeLocation converts an API generated location object into UnitLocation
 * @param {JSON} l - The location JSON object
 * @return {UnitLocation} - A class based representation of the location
 */

exports.decodeLocation = function (l) {
  return new UnitLocation(l.name, l.address, l.lat, l.lng, l.geoname, l.siteid, l.areaid, l.country, l.countryCode, l.postalCode, l.timezone, l.currency, l.gridID);
}; // The name "Location" conflicts with window.Location


var UnitLocation =
/** @class */
function () {
  function UnitLocation(name, address, lat, lng, geoname, siteid, areaid, country, countryCode, postalCode, timezone, currency, gridID) {
    if (gridID === void 0) {
      gridID = "";
    }

    this.name = name;
    this.address = address;
    this.lat = lat;
    this.lng = lng;
    this.geoname = geoname;
    this.siteid = siteid;
    this.areaid = areaid;
    this.country = country;
    this.countryCode = countryCode;
    this.postalCode = postalCode;
    this.timezone = timezone;
    this._currency = currency;
    this.gridID = gridID;
  }

  ;
  Object.defineProperty(UnitLocation.prototype, "currency", {
    get: function get() {
      if (this._currency) {
        return this._currency;
      }

      if (this.geoname.substr(0, 2) === 'Sw') {
        return 'sek';
      }

      return 'eur';
    },
    set: function set(currency) {
      this._currency = currency;
    },
    enumerable: false,
    configurable: true
  });
  ;

  UnitLocation.prototype.getCurrencySymbol = function () {
    var currency = this.currency;

    if (currency === 'sek') {
      return 'Kr';
    }

    if (currency === 'eur') {
      return '€';
    }

    if (currency === 'nok') {
      return 'Kr';
    }

    if (currency === 'dkk') {
      return 'Kr';
    }

    return '€';
  };

  UnitLocation.prototype.getSpotRegion = function () {
    var ret = 'SE3';

    if (this.geoname) {
      var area = this.geoname.split('/')[1];

      if (area.length > 1 && area === 'Scania') {
        ret = 'SE4';
      }

      if (this.geoname.substr(0, 2) === 'Fi') {
        ret = 'FI';
      }
    }

    return ret;
  };

  UnitLocation.prototype.tokenizeName = function () {
    return this.name.split(",").map(function (token) {
      return token.trim();
    });
  };

  UnitLocation.prototype.encode = function () {
    var rawLocation = {};

    if (this.name != null && this.name.length > 0) {
      rawLocation["name"] = this.name;
    }

    if (this.address != null && this.address.length > 0) {
      rawLocation["address"] = this.address;
    }

    if (this.lat !== 0.0 || this.lng !== 0.0) {
      rawLocation["lat"] = this.lat;
      rawLocation["lng"] = this.lng;
    }

    if (this.geoname != null && this.geoname.length > 0) {
      rawLocation["geoname"] = this.geoname;
    }

    if (this.siteid != null && this.siteid.length > 0) {
      rawLocation["siteid"] = this.siteid;
    }

    if (this.areaid != null && this.areaid.length > 0) {
      rawLocation["areaid"] = this.areaid;
    }

    if (this.country != null && this.country.length > 0) {
      rawLocation["country"] = this.country;
    }

    if (this.countryCode != null && this.countryCode.length > 0) {
      rawLocation["countryCode"] = this.countryCode;
    }

    if (this.postalCode != null && this.postalCode.length > 0) {
      rawLocation["postalCode"] = this.postalCode;
    }

    if (this.currency != null && this.currency.length > 0) {
      rawLocation["currency"] = this.currency;
    }

    if (this.timezone != null && this.timezone.length > 0) {
      rawLocation["timezone"] = this.timezone;
    }

    if (this.gridID != null && this.gridID.length > 0) {
      rawLocation["gridID"] = this.gridID;
    }

    return rawLocation;
  };

  return UnitLocation;
}();

exports.UnitLocation = UnitLocation;
;
exports.default = UnitLocation;